import { Box, useToast } from "@chakra-ui/react";
import BreadCrumbMaker from "../../../components/BreadCrumbMaker";
import Form from "./Form";
import { useEffect, useRef, useState } from "react";
import { createNewDriver } from "../../../actions/inventory/driver.action";
import { useNavigate } from "react-router-dom";
import driverValidationSchema from "./validation.jsx";

const AddDriver = () => {
  const [data, setData] = useState({});
  const formRef = useRef();
  const toast = useToast();
  const navigate = useNavigate();


  // console.log("data Add kia "+ JSON.stringify(data));
  // Formik ab values dega, event nahi
  const handleSubmit = async (values) => {
    try {
      const merged = { ...data, ...values };
      // console.log('=== Current data state BEFORE FormData ===');
      // console.log('Full data object:', merged);
      // console.log('drivingLicenseFront:', merged.drivingLicenseFront instanceof File ? 'FILE' : merged.drivingLicenseFront);
      // console.log('drivingLicenseBack:', merged.drivingLicenseBack instanceof File ? 'FILE' : merged.drivingLicenseBack);
      // console.log('aadhaarCardFront:', merged.aadhaarCardFront instanceof File ? 'FILE' : merged.aadhaarCardFront);
      // console.log('aadhaarCardBack:', merged.aadhaarCardBack instanceof File ? 'FILE' : merged.aadhaarCardBack);
      // console.log('panCardFront:', merged.panCardFront instanceof File ? 'FILE' : merged.panCardFront);
      // console.log('panCardBack:', merged.panCardBack instanceof File ? 'FILE' : merged.panCardBack);

      const formData = new FormData();
      const fileFields = {
        'drivingLicenseFront': true,
        'drivingLicenseBack': true,  // Changed to true - backend requires it
        'aadhaarCardFront': true,
        'aadhaarCardBack': true,
        'panCardFront': true,
      };

      console.log('=== Processing FormData ===');
      Object.keys(merged).forEach((key) => {
        const value = merged[key];
        if (value === undefined || value === null) {
          console.log(`⊘ Skipping ${key} - undefined/null`);
          return;
        }
        if (key in fileFields) {
          console.log(`Processing file field: ${key}`);
          if (fileFields[key] === false) {
            console.log(`⊘ Skipping ${key} - not accepted by backend`);
            return;
          }
          if (value instanceof File) {
            formData.append(key, value);
            console.log(`✓ Added file ${key}:`, value.name, value.size, 'bytes');
          }
          else if (Array.isArray(value) && value.length > 0 && value[0] instanceof File) {
            formData.append(key, value[0]);
            console.log(`✓ Added file from array ${key}:`, value[0].name);
          }
          else if (typeof value === 'string' && value !== '') {
            console.log(`⊘ Skipping existing file URL for ${key}:`, value.substring(0, 50));
          }
          else {
            console.log(`⚠️ File field ${key} has unexpected type:`, typeof value);
          }
        }
        else if (typeof value === "boolean") {
          formData.append(key, value);
        }
        else if (value !== "") {
          formData.append(key, value);
        }
      });

      // console.log('=== FormData Contents ===');
      // let fileCount = 0;
      // const fileInfo = {};
      // for (let pair of formData.entries()) {
      //   if (pair[1] instanceof File) {
      //     fileCount++;
      //     fileInfo[pair[0]] = `File: ${pair[1].name} (${pair[1].size} bytes)`;
      //   } else {
      //     console.log(pair[0], '->', pair[1]);
      //   }
      // }
      // console.log('=== Files to Upload ===');
      // console.log(fileInfo);
      // console.log('Total files:', fileCount);


      const response = await createNewDriver(formData);

      toast({
        title: "Success",
        description: "Driver added successfully",
        status: "success",
        duration: 3000,
      });

      localStorage.removeItem("AddDriverFormDraft");

      navigate("/fleet-management/driver");

    } catch (error) {
      console.error("Error adding driver:", error);
      console.error("Error response:", error.response);
      console.error("Error data:", error.response?.data);

      const errorMessage = error.response?.data?.message
        || error.response?.data?.error
        || error.message
        || "Failed to add driver";

      toast({
        title: "Error",
        description: errorMessage,
        status: "error",
        duration: 5000,
      });
    }
  };

  useEffect(() => {
    const savedDraft = localStorage.getItem("AddDriverFormDraft");
    if (savedDraft && savedDraft !== "undefined") {
      try {
        const parsedData = JSON.parse(savedDraft);
        setData(parsedData);
      } catch (error) {
        console.error("Failed to parse saved draft:", error);
        localStorage.removeItem("AddDriverFormDraft");
      }
    }
  }, []);

  useEffect(() => {
    if (data && Object.keys(data).length > 0) {

      const dataToSave = {};
      Object.keys(data).forEach(key => {
        if (!(data[key] instanceof File)) {
          dataToSave[key] = data[key];
        }
      });
      if (Object.keys(dataToSave).length > 0) {
        localStorage.setItem("AddDriverFormDraft", JSON.stringify(dataToSave));
      }
    }
  }, [data]);

  return (
    <Box w={"100%"} justifyContent={"center"} spacing={10} p={6}>
      <BreadCrumbMaker
        items={[
          { link: "", title: "Fleet Management" },
          {
            link: "/fleet-management/driver",
            title: "Driver",
          },
          {
            link: "/fleet-management/driver/add",
            title: "Add Driver",
            on: true,
          },
        ]}
      />
      <Form
        data={data}
        setData={setData}
        handleSubmit={handleSubmit}
        formRef={formRef}
        validationSchema={driverValidationSchema}
      />
    </Box>
  );
};

export default AddDriver;